import { combineReducers } from 'redux';

import { connectRouter } from 'connected-react-router';
import { abTestingReducer as abTesting } from 'app/shared/ab-testing';
import { LabsterStore } from '@zg-rentals/particles-js-labster';
import address from './address';
import analytics from './analytics';
import app from './app';
import emailVerification from './emailVerification';
import lead from './lead'; // use alias
import modal from './modal';
import notification from './notification';
import properties from './properties';
import reviews from './reviews';
import statistic from './statistic';
import user from './user';
import paidInclusion from './paidInclusion';
import env from './env';
import billing from './billing';
import userManagement from './userManagement';
import claimListings from './claimListings';

const rootReducer = history => combineReducers({
    abTesting,
    address,
    analytics,
    app,
    env,
    emailVerification,
    LabsterStore,
    lead,
    modal,
    notification,
    properties,
    reviews,
    paidInclusion,
    statistic,
    user,
    billing,
    userManagement,
    claimListings,
    router: connectRouter(history),
});

export default rootReducer;
